function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.3332 16.3349V26.2224H21.6177V16.9971C21.6177 14.6796 20.791 13.0981 18.7221 13.0981C17.1429 13.0981 16.203 14.1639 15.7895 15.195C15.6388 15.5636 15.6 16.0766 15.6 16.5926V26.2224H9.8825C9.8825 26.2224 9.95951 10.5978 9.8825 8.97897H15.5994V11.4232C15.5878 11.4414 15.5727 11.4611 15.5618 11.4789H15.5994V11.4232C16.3589 10.2499 17.7154 8.57388 20.7516 8.57388C24.5132 8.57382 27.3332 11.0384 27.3332 16.3349ZM3.90178 0.666504C1.94585 0.666504 0.666504 1.95317 0.666504 3.64517C0.666504 5.3003 1.90883 6.62602 3.82589 6.62602H3.86408C5.8579 6.62602 7.09787 5.30055 7.09787 3.64517C7.0603 1.95317 5.8579 0.666504 3.90178 0.666504ZM1.00603 26.222H6.72131V8.97863H1.00603V26.222Z",
  fill: "#09BAD3"
});

var SvgLinkedinIc = function SvgLinkedinIc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedinIc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin_ic.ab8cd507.svg";
export { ForwardRef as ReactComponent };